import { render, staticRenderFns } from "./VersionCard.Vue?vue&type=template&id=274bfe68"
import script from "./VersionCard.Vue?vue&type=script&lang=js"
export * from "./VersionCard.Vue?vue&type=script&lang=js"
import style0 from "./VersionCard.Vue?vue&type=style&index=0&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/VersionCard.Vue
// module id = 81
// module chunks = 0